import { Component, inject, input, output, effect } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { HolidaysService } from 'src/app/shared/services/holidays/holidays.service';

@Component({
  selector: 'app-vacation-switch',
  imports: [MatSlideToggleModule],
  templateUrl: './vacation-switch.component.html',
  styleUrls: ['./vacation-switch.component.css'],
})
export class VacationSwitchComponent {
  isActive: boolean = true;
  exerciseId = input<number>();
  exerciseActive = input<boolean>();
  statusChanged = output<void>();

  constructor() {
    // Use effect to react to input signal changes
    effect(() => {
      const active = this.exerciseActive();
      console.log('exerciseActive value:', active, 'type:', typeof active);
      this.isActive = typeof active === 'boolean' ? active : false;
    });
  }

  private readonly holidayService = inject(HolidaysService);

  // Emit event when toggle is changed
  onToggleChange() {
    this.isActive = !this.isActive;
  }

  onToggleChangeWithLog(event: any) {
    this.isActive = event.checked;
    const id = this.exerciseId();
    if (typeof id === 'number') {
      this.holidayService
        .changeExerciseActiveStatus(id, this.isActive)
        .subscribe({
          next: (response) => {
            console.log('Exercise status updated successfully:', response);
            this.statusChanged.emit();
          },
          error: (error) => {
            console.error('Error updating exercise status:', error);
          },
        });
    } else {
      console.error('exerciseId is undefined or not a number.');
    }
    // console.log('Toggle value:', this.isActive);
  }
}
